export enum ProviderTypes {
    custom,
    airTable
}



export enum FormMode {
    edit,
    create,
    search
}